import { useCallback } from 'react';

export const useAppConfig = () => {
  const campusHasZones = useCallback((currentCampusData: any) => {
    let hasZones = false;
    if (currentCampusData.buildings) {
      for (const building of currentCampusData.buildings) {
        // check each building for thermal zones
        if (building.thermalZones && building.thermalZones.length > 0) {
          hasZones = true;
          break;
        }
      }
    } else {
      hasZones = true;
    }
    return hasZones;
  }, []);

  return {
    campusHasZones,
  };
};
